import * as React from "react";

import Functions from "./Functions";
import ListItem, {
  FunctionsListItemProps as ListItemProps,
} from "./FunctionsListItem";
import YTOverlay from "./YTOverlay";
import * as constants from "../constants";

export interface FunctionsProps {
  listItems?: ListItemProps[];
  videoId?: string;
}

interface FunctionsState {
  isVideoExpanded: boolean;
}

class FunctionsContainer extends React.Component<
  FunctionsProps,
  FunctionsState
> {
  public static defaultProps: Partial<FunctionsProps> = {
    listItems: constants.FUNCTION_DATA,
    videoId: constants.VIDEO_ID,
  };

  public state: FunctionsState = {
    isVideoExpanded: false,
  };

  private toggleVideoExpand = () =>
    this.setState(state => ({
      ...state,
      isVideoExpanded: !state.isVideoExpanded,
    }));

  private getThumbnailSrc = () =>
    `https://img.youtube.com/vi/${this.props.videoId}/maxresdefault.jpg`;

  private getVideoSrc = () =>
    `https://www.youtube.com/embed/${this.props.videoId}?autoplay=1`;

  private renderListItems = () =>
    (this.props.listItems as ListItemProps[]).map((props, i) => (
      <ListItem key={i} {...props} />
    ));

  public render(): any {
    const shadow = [
      <Functions
        key="function-panel"
        toggleVideoExpand={this.toggleVideoExpand}
        thumbnailSrc={this.getThumbnailSrc()}
      >
        {this.renderListItems()}
      </Functions>,
    ];

    if (this.state.isVideoExpanded) {
      shadow.push(
        <YTOverlay
          key="yt-overlay"
          onClose={this.toggleVideoExpand}
          videoSrc={this.getVideoSrc()}
        />,
      );
    }

    return shadow;
  }
}

export default FunctionsContainer;



// WEBPACK FOOTER //
// ./src/routes/LandingPage/components/FunctionsContainer.tsx